import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    merchant_id: yup.string().required("Merchant ID is required"),
    terminal_id: yup.string().required("Terminal ID is required"),
    store_id: yup.string().required("Store is required"),
    terminal_sn: yup.string().required("Serial number is required"),
  })
  .required("All fields are required");

const useValidation = ({ ...formDetails }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...formDetails,
    },
  });
};

export default useValidation;
